import routerOptions0 from "/app/src/app/router.options.ts";
import routerOptions1 from "/app/node_modules/.pnpm/nuxt@3.3.3_@types+node@18.19.3_rollup@3.29.4_sass@1.69.5_terser@5.39.0_typescript@4.9.5/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}